import{css}from'glamor';/**
 * Creates a class name for the flex-grow property
 * @param {number} [value=0] The value for the flex-grow property
 * @return {string} The class name
 */var grow=function grow(){var value=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;return css({flexGrow:value}).toString();};/**
 * Creates a class name for the flex-shrink property
 * @param {number} [value=0] The value for the flex-shrink property
 * @return {string} The class name
 */var shrink=function shrink(){var value=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return css({flexShrink:value}).toString();};export default{grow:grow,shrink:shrink};